import { Controller } from "@hotwired/stimulus"

// The location chip on Earth (community/_world_bar): which city you're in and where else you can go.
// Cities come from the server; a city's own places arrive from the 3D city once it has loaded (the
// "jane-worlds:places" window event, also kept on window.JaneWorlds.places for a late connect), and
// picking one asks the city to take you there ("jane-worlds:goto"). A coming-soon city takes a
// "Want it" (CommunityPlacesController#interest) - the first step of members choosing what gets built.
export default class extends Controller {
    static targets = ["chip", "menu", "places", "placesList", "count"]

    connect() {
        this.onPlaces = (e) => this.#renderPlaces(e.detail?.places)
        window.addEventListener("jane-worlds:places", this.onPlaces)
        this.#renderPlaces(window.JaneWorlds?.places)
        this.onOutside = (e) => { if (!this.element.contains(e.target)) this.close() }
        this.onKey = (e) => { if (e.key === "Escape" && !this.menuTarget.hidden) { e.stopImmediatePropagation(); this.close(); this.chipTarget.focus() } }
        document.addEventListener("pointerdown", this.onOutside, true)
        window.addEventListener("keydown", this.onKey, true)
    }

    disconnect() {
        window.removeEventListener("jane-worlds:places", this.onPlaces)
        document.removeEventListener("pointerdown", this.onOutside, true)
        window.removeEventListener("keydown", this.onKey, true)
    }

    toggle() {
        this.menuTarget.hidden ? this.open() : this.close()
    }

    open() {
        this.menuTarget.hidden = false
        this.chipTarget.setAttribute("aria-expanded", "true")
    }

    close() {
        this.menuTarget.hidden = true
        this.chipTarget.setAttribute("aria-expanded", "false")
    }

    go(event) {
        const id = event.currentTarget.dataset.place
        window.dispatchEvent(new CustomEvent("jane-worlds:goto", { detail: { id } }))
        this.close()
    }

    async want(event) {
        const button = event.currentTarget
        button.disabled = true
        try {
            const response = await fetch(button.dataset.path, {
                method: "POST",
                headers: { Accept: "application/json", "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "" },
                credentials: "same-origin"
            })
            if (!response.ok) throw new Error(String(response.status))
            const data = await response.json()
            button.textContent = "Wanted"
            button.setAttribute("aria-pressed", "true")
            this.countTargets.filter((el) => el.dataset.key === button.dataset.key).forEach((el) => { el.textContent = `Coming soon · ${data.count} want it` })
        } catch (_e) {
            button.disabled = false
        }
    }

    #renderPlaces(places) {
        if (!places?.length || !this.hasPlacesListTarget) return
        this.placesListTarget.replaceChildren(...places.map((place) => {
            const b = document.createElement("button")
            b.type = "button"
            b.className = "cc-location-item"
            b.setAttribute("role", "menuitem")
            b.dataset.place = place.id
            b.dataset.action = "community-location#go"
            b.title = place.blurb || ""
            b.textContent = place.name
            return b
        }))
        this.placesTarget.hidden = false
    }
}
